// Accept file type and max size refer to https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media
export const ACCEPTED_ATTACHMENT_TYPES = {
  'image/*': ['.png', '.jpeg', '.jpg', '.webp'],
  'video/*': ['.mp4', '.3gp'],
  'audio/*': ['.aac', '.mp3', '.mpeg', '.amr', '.ogg'],
  'text/*': ['.plain', '.txt', '.csv'],
  'application/pdf': [],
  'application/vnd.ms-powerpoint': [],
  'application/msword': [],
  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
};

export const getAcceptedAttachmentTypesString = () => {
  const extensions: string[] = [];

  Object.entries(ACCEPTED_ATTACHMENT_TYPES).forEach(([mimeType, exts]) => {
    if (exts.length > 0) {
      extensions.push(...exts);
    } else {
      extensions.push(mimeType);
    }
  });

  return extensions.join(',');
};

export const MAX_SIZE = {
  sticker: 100 * 1024,
  image: 5 * 1024 * 1024,
  audio: 16 * 1024 * 1024,
  video: 16 * 1024 * 1024,
  pdf: 100 * 1024 * 1024,
  document: 100 * 1024 * 1024,
};

/**
 * Format file size in bytes to human readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i];
};

/**
 * Check if file is an image type
 */
export const isImageFile = (type: string): boolean => {
  return type.startsWith('image/');
};

/**
 * Check if file is a video type
 */
export const isVideoFile = (type: string): boolean => {
  return type.startsWith('video/');
};

/**
 * Check if file is an audio type
 */
export const isAudioFile = (type: string): boolean => {
  return type.startsWith('audio/');
};

/**
 * Check if file is a PDF type
 */
export const isPDFFile = (type: string): boolean => {
  return type === 'application/pdf';
};

/**
 * Get maximum file size based on file type
 */
export const getMaxFileSize = (file: File): number => {
  if (isImageFile(file.type)) return MAX_SIZE.image;
  if (isVideoFile(file.type)) return MAX_SIZE.video;
  if (isAudioFile(file.type)) return MAX_SIZE.audio;
  if (isPDFFile(file.type)) return MAX_SIZE.pdf;
  return MAX_SIZE.document;
};

/**
 * Create preview for image files
 */
export const createFilePreview = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    if (isImageFile(file.type)) {
      const reader = new FileReader();

      reader.onload = (e) => resolve((e.target?.result as string) || '');
      reader.readAsDataURL(file);
    } else {
      resolve('');
    }
  });
};
